// src/pages/components/TabelaMaquinas.jsx

import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    IconButton, Tooltip, Chip, CircularProgress, Box
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';

const StatusChip = ({ status }) => {
    const statusConfig = {
        S: { label: 'Ativo', color: 'success' },
        N: { label: 'Inativo', color: 'error' },
        M: { label: 'Manutenção', color: 'warning' },
    };

    const config = statusConfig[status] || { label: 'Não informado', color: 'default' };

    return <Chip label={config.label} color={config.color} size="small" />;
};

export default function TabelaMaquinas({ terminais, onEdit, onDelete, loadingState }) {
    const { loading, deletingId } = loadingState;
    
    if (loading === 'fetching' || loading === 'searching') {
        return <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress color="inherit"  /></Box>
    }

    if (terminais.length === 0) {
        return <Box sx={{ textAlign: 'center', p: 5 }}>Nenhum terminal encontrado.</Box>
    }

    return (
        <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="tabela de máquinas">
                <TableHead>
                    <TableRow sx={{ '& th': { fontWeight: 'bold' } }}>
                        <TableCell>Código</TableCell>
                        <TableCell>Nome da Máquina</TableCell>
                        <TableCell>Operador</TableCell>
                        <TableCell align="center">Status</TableCell>
                        <TableCell align="center">Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {terminais.map((machine) => (
                        <TableRow key={machine.id} hover>
                            <TableCell>{machine.cod_maquina}</TableCell>
                            <TableCell>{machine.nm_maquina}</TableCell>
                            <TableCell>{machine.operador}</TableCell>
                            <TableCell align="center">
                                <StatusChip status={machine.ativo} />
                            </TableCell>
                            <TableCell align="center">
                                <Tooltip title="Editar">
                                    <IconButton color="primary" onClick={() => onEdit(machine)}>
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Excluir">
                                    <IconButton color="error" onClick={() => onDelete(machine.id)} disabled={deletingId === machine.id}>
                                        {deletingId === machine.id ? <CircularProgress size={22} color="inherit" /> : <DeleteIcon />}
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}